// extracted by mini-css-extract-plugin
module.exports = {"Container":"Main_Container__3by4U","LogContainer":"Main_LogContainer__HQBBL","Title":"Main_Title__1R43Q"};